import request from '@/utils/request'
import { getToken } from '@/utils/auth'
import { parseSseStream } from '@/components/AiAssistant/stream'

const base = '/ai/chat'
export const getAiConfig = () => request({ url: `${base}/config`, method: 'get' })
export const getSessions = page => request({ url: `${base}/sessions`, method: 'get', params: { page } })
export const getMessages = (id, page) => request({ url: `${base}/sessions/${encodeURIComponent(id)}/messages`, method: 'get', params: { page } })
export const deleteSession = id => request({ url: `${base}/sessions/delete`, method: 'post', data: { id } })

export async function streamReply(input, signal, onEvent) {
  const response = await fetch(`${process.env.BASE_API.replace(/\/$/, '')}${base}/stream`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', 'X-TOKEN': getToken(), Accept: 'text/event-stream' },
    body: JSON.stringify(input), signal
  })
  if (!response.ok || !(response.headers.get('content-type') || '').includes('text/event-stream')) {
    const body = await response.json().catch(() => ({}))
    if (body.errorCode === '0001') {
      // Go through the existing request layer for the shared expired-login/impersonation flow.
      await getAiConfig()
    }
    throw new Error(body.extMessage || body.errorMessage || `AI request failed (${response.status}).`)
  }
  return parseSseStream(response.body, onEvent)
}
